/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Newsletter_BodyInputs */

const ja_playdata_home_newsletter_body = /** @type {(inputs: Playdata_Home_Newsletter_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`視聴者数データに基づいた、eスポーツ大会の簡易分析レポートを定期的にお届けします。`)
};

const en_playdata_home_newsletter_body = /** @type {(inputs: Playdata_Home_Newsletter_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regular short-form analysis of Japanese esports events, based on viewership data.`)
};

/**
* | output |
* | --- |
* | "Regular short-form analysis of Japanese esports events, based on viewership data." |
*
* @param {Playdata_Home_Newsletter_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_newsletter_body = /** @type {((inputs?: Playdata_Home_Newsletter_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Newsletter_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_newsletter_body(inputs)
	return en_playdata_home_newsletter_body(inputs)
});